import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteCampaignPayload } from '@app-store/slices/campaigns/deleteCampaign'

interface TaskAction extends Action {
    payload: IDeleteCampaignPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.campaigns.deleteCampaign

function* deleteCampaignSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/notifications/campaigns/${payload.campaignId}`)
        if (response.success) {
            yield put(payload?.sagaCB.onSuccess())
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Campaign removed successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteCampaignSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteCampaignSagaTask)
}

export default deleteCampaignSaga
